var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00039 2.40002H18.0004C19.9886 2.40002 21.6004 4.0118 21.6004 6.00002V18C21.6004 19.9882 19.9886 21.6 18.0004 21.6H6.00039C4.01217 21.6 2.40039 19.9882 2.40039 18V6.00002C2.40039 4.0118 4.01217 2.40002 6.00039 2.40002ZM6.00039 3.60002C4.67491 3.60002 3.60039 4.67454 3.60039 6.00002V18C3.60039 19.3255 4.67491 20.4 6.00039 20.4H18.0004C19.3259 20.4 20.4004 19.3255 20.4004 18V6.00002C20.4004 4.67454 19.3259 3.60002 18.0004 3.60002H6.00039Z",
    fill: "#B5B5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/checkBox.03f8ac2db4e235d8e23ee373506f3e59.svg";
export { ForwardRef as ReactComponent };